import React, { useState } from "react";
import { Modal, Button } from "react-bootstrap";
import { displayFormattedDate } from "../../services/commonService";
import RelevanceScore from "./RelevanceScore";

export default function NudgeModal({ nudgeData, handleClose, is_side_card }) {

  return (
    <>
      <Modal show="true" onHide={handleClose} centered className={`nudges_modal_custom modal-lg ${is_side_card ? 'nudgeSideCardModal' : '' }`}>
        <Modal.Header closeButton className={`custom_header_close ${nudgeData?.impact_score >= 8 ? 'active' : '' }`}>
          <Modal.Title className="custom_icon_back">
            
           Nudge · {nudgeData?.event}
            {nudgeData?.impact_score >= 8 && (
              <div className="contet_head_img">
                <img
                  src="/img/icons/trending-up_backcolor.png"
                  alt="image"
                  className="image_block"
                />
              </div>
            )}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="row mb-3">
            <div className="col-md-12 full-width-nudges">
              <div className="content_para">
                {/* {nudgeData?.event && (
                  <h6 className="content_main_head">{nudgeData?.event}</h6>
                )} */}
                <div className="content_nudges_para">

                <div className="potential_impact">
                    <span className="nudges_full_span">Potential Impact:</span> <br />
                    <div style={{marginLeft: '10px'}}>{nudgeData?.potential_impact}</div>
                  </div>

                  {nudgeData?.relevant_solutions &&
                  <div className="potential_impact">
                  <span className="nudges_full_span">RELEVANT SOLUTION(S):</span> <br />
                  <ul>
                    {nudgeData?.relevant_solutions?.map((solution, index) => (
                      <li key={index}>
                        {typeof solution === 'string' ? (
                          solution
                        ) : (
                          <div>
                              {solution?.name && <strong>{solution.name}</strong>}

                              {Object.entries(solution || {})
                                .filter(
                                  ([key, value]) =>
                                    key !== "name" && typeof value === "string" && value.trim() !== ""
                                )
                                .map(([key, value]) => (
                                  <p key={key}>{value}</p>
                                ))}
                            </div>

                               )}
                              </li>))}
                        </ul>
                  </div>
                  }

                  {nudgeData?.value_selling_prompters &&
                  <div className="potential_impact">
                  <span className="nudges_full_span">Value Selling Prompters:</span> <br />
                    <ul>
                      {nudgeData?.value_selling_prompters?.map((value_selling_prompter, index) => (
                        <li key={index}>{value_selling_prompter}</li>
                      ))}
                    </ul>
                  </div>
                  }

                  {/* <div className="row mb-3 mt-1">
                    {nudgeData?.impact_score && (
                    <div className="col-md-6">
                        <b className="mr-1">Impact Score: </b>{" "}
                        {nudgeData.impact_score}/10
                    </div>
                    )}

                    {nudgeData?.event_date && (
                    <div className="col-md-6 align-right">
                        
                        {displayFormattedDate (nudgeData.event_date, 'YYYY-MM-DD', true)}
                    </div>
                    )}                    
                  </div> */}

                  <div className="date_company_impact_block">
                  <div className="impact_company_block">
                      <div className="impact_score">
                      {nudgeData?.impact_score && (
                        // <p className="impact_score_text green_impact">Impact Score:  {" "}{nudgeData.impact_score}/10</p>
                        <RelevanceScore
                            relevanceScore={nudgeData.impact_score}
                            section="impact_score"
                        />
                      )}
                      </div>
                  </div>
                  <span className="date_italic">{displayFormattedDate (nudgeData.event_date, 'YYYY-MM-DD', true)}</span>
              </div>
                  
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}
